import { useMutation, useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { useAuth } from '@/lib/auth'
import { Alert, Kpi, KpiGrid, Muted, PageHeader, Section } from '@/components/ui'
import {
  fetchBitrixColaboradores,
  fetchRhsolutioHealth,
  fetchRhsolutioPendencias,
  unwrapList,
} from './api'

export function IntegracoesPage() {
  const { canEdit } = useAuth()

  const pendencias = useQuery({
    queryKey: ['integracoes', 'rhsolutio', 'pendencias'],
    queryFn: fetchRhsolutioPendencias,
  })

  const bitrix = useQuery({
    queryKey: ['integracoes', 'bitrix', 'colaboradores'],
    queryFn: async () => unwrapList(await fetchBitrixColaboradores()),
    retry: false,
  })

  const health = useMutation({
    mutationFn: fetchRhsolutioHealth,
  })

  return (
    <section className="hi-page">
      <PageHeader
        title="Integrações"
        subtitle="Status Bitrix / RHID / RH Solutio. Syncs manuais avançados no legado."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/integracoes')}>
            Legado
          </a>
        }
      />

      <KpiGrid>
        <Kpi
          label="Pendências Solutio"
          value={String(pendencias.data?.pendentes ?? '—')}
        />
        <Kpi
          label="Colaboradores Bitrix"
          value={bitrix.isError ? '—' : String(bitrix.data?.length ?? '…')}
        />
      </KpiGrid>

      <Section title="RH Solutio">
        {pendencias.isLoading ? <Muted>Carregando pendências…</Muted> : null}
        {pendencias.isError ? (
          <Alert tone="warning">
            {pendencias.error instanceof ApiError
              ? pendencias.error.message
              : 'Pendências indisponíveis (conta sem vínculo?).'}
          </Alert>
        ) : null}
        {pendencias.data?.mensagem ? <Muted>{pendencias.data.mensagem}</Muted> : null}
        {canEdit('integracoes') ? (
          <div className="hi-actions">
            <button
              type="button"
              className="btn btn-primary"
              disabled={health.isPending}
              onClick={() => health.mutate()}
            >
              {health.isPending ? 'Testando…' : 'Testar health Solutio'}
            </button>
          </div>
        ) : null}
        {health.isSuccess ? (
          <Alert tone={health.data?.sucesso ? 'success' : 'danger'}>
            {String(health.data?.mensagem || JSON.stringify(health.data))}
          </Alert>
        ) : null}
        {health.isError ? (
          <Alert tone="danger">
            {health.error instanceof ApiError ? health.error.message : 'Health check falhou.'}
          </Alert>
        ) : null}
      </Section>

      <Section title="Bitrix">
        {bitrix.isLoading ? <Muted>Carregando…</Muted> : null}
        {bitrix.isError ? (
          <Alert tone="warning">
            {bitrix.error instanceof ApiError
              ? bitrix.error.message
              : 'Bitrix indisponível ou sem permissão.'}
          </Alert>
        ) : (
          <Muted>{bitrix.data?.length ?? 0} colaborador(es) retornados pela API.</Muted>
        )}
      </Section>
    </section>
  )
}
